import { styled } from "@mui/material";
import * as React from "react";
import { LocalVideoTrack, RemoteVideoTrack } from "twilio-video";
import useMediaStreamTrack from "../hooks/useMediaStreamTrack";

const Video = styled("video")({
	width: "100%",
	height: "100%",
});

interface Props {
	track: LocalVideoTrack | RemoteVideoTrack;
	isLocal?: boolean;
}

const VideoTrack = ({ track, isLocal }: Props) => {
	const ref = React.useRef<HTMLVideoElement>(null!); // Not null

	const mediaStreamTrack = useMediaStreamTrack(track);

	React.useEffect(() => {
		const el = ref.current;
		el.muted = true;

		track.attach(el);

		return () => {
			track.detach(el);
		};
	}, [track]);

	const rotate = mediaStreamTrack?.getSettings().facingMode !== "environment";

	return (
		<Video
			ref={ref}
			style={{
				transform: isLocal && rotate ? "rotateY(180deg)" : "",
				objectFit: "cover",
			}}
		/>
	);
};

export default VideoTrack;
